import React, { Component } from "react";
import styles from "./MenuToggle.module.css";
import Svg from "../Svg/Svg";

class MenuToggle extends Component {
  render() {
    const { menuOpen, onMenuToggle } = this.props;

    return (
      <button
        aria-label="Menu toggle button"
        className={styles.MenuToggle}
        onClick={onMenuToggle}
      >
        <div className={styles.bars}>
          <Svg
            id="menu-toggle-bar"
            className={menuOpen ? styles.bar1Open : styles.bar1}
          />
          <Svg
            id="menu-toggle-bar"
            className={menuOpen ? styles.bar2Open : styles.bar2}
          />
          <Svg
            id="menu-toggle-bar"
            className={menuOpen ? styles.bar3Open : styles.bar3}
          />
        </div>

        <div className={styles.checkMark}>
          <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" strokeLinecap="square">
              <path
                d="M6 12 L12 16 L18 6"
                stroke="#F5F5F5"
                strokeWidth="6"
                className={styles.path}
              />
            </g>
          </svg>
        </div>
      </button>
    );
  }
}

export default MenuToggle;
